import { memo, useCallback, useState } from "react";
import { Link } from "react-router-dom";

import { Pagination, Table, Tooltip } from "antd";
import Image from "components/Image";
import { useMediaQuery } from "react-responsive";
import { Bounce, toast } from 'react-toastify';
import { isEventUpcoming } from "utils/common";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import AllEmployeeAddPopup from "../../../../components/modelpopup/AllEmployeeAddPopup";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import EmployeeListFilter from "./../components/EmployeeListFilter";


import {
    CustomRow,
    itemRender,
    pageSizeOptions
} from "utils/table";

import { resendInvitation } from "api/services/employee";
import { Button } from "components/Button";
import FilterDrawer from "components/Drawer/filterDrawer";
import { SkeltonLoader } from "components/skeltonLoader";
import { formatDateHandler2 } from "utils/common";
import { useEmployee } from "./../context/employeeContext";


const AllEmployee = () => {
  const {
    loading,
    loadingMore,
    employeeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleEmployeeDetailPage,
    handleDateChange,
    handleClearAll,
    isFilterDirty,
    appliedFilterCount,
    handleExport,
    exportLoading
  } = useEmployee();
  const [invitationLoader, setInvitationLoader] = useState(false)



  const handleResend = useCallback((employee) => {
    console.log(employee, "KKK")
    setInvitationLoader(true)
    resendInvitation({company_user : employee?.id}).then(res=>{
      toast.success('Invitation mail send successfully', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setInvitationLoader(false)
    }).catch(err=>{
      toast.error('Failed to send invitation mail', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setInvitationLoader(false)
    })
  }, []);

  const iconGenerator = (data) =>{
    if(data === "completed" || data === true){
      return "fa fa-check-circle"
    }
    else if(data === "partial"){
      return "fa fa-exclamation-circle"
    }
    else if(data === "empty" || data === false){
      return "fa fa-times-circle"
    }
    return "fa fa-check-circle"
  }
  const statusGenerator = (data) =>{
    if(data === "empty" || data === false){
      return "danger"
    }
    if(data === "partial"){
      return "warning"
    }
    if(data === "completed" || data === true){
      return "success"
    }
    return "primary"
  }
  const columns = [
    // {
    //   title: "Employee id",
    //   dataIndex: "id",
    //   sorter: true,
    //   // render: (text, record) => (
    //   //   <span className="table-avatar">
    //   //     <Link to="/profile" className="avatar">
    //   //       <img alt="" src={record.image} />
    //   //     </Link>
    //   //     <Link to="/profile">
    //   //       {text} <span>{record.role}</span>
    //   //     </Link>
    //   //   </span>
    //   // ),
    //   // sorter: (a, b) => a.name.length - b.name.length,
    // },
    {
      title: "Image",
      dataIndex: "profile_image",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          <button 
            type="button"
            onClick={()=>handleEmployeeDetailPage(record.id, index)} 
            className="avatar"
            style={{ border: "none", background: "none", padding: 0, cursor: "pointer" }}
          >
            <Image  src={record?.profile_image} type="user" alt="User" style={{ objectFit: "cover" }} />
          </button>
        </span>
      ),
      // sorter: (a, b) => a.emp_no.length - b.emp_no.length,
    },
    {
      title: "Emp No",
      dataIndex: "emp_no",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          <button 
            type="button"
            onClick={()=>handleEmployeeDetailPage(record.id, index)}
            style={{ border: "none", background: "none", padding: 0, cursor: "pointer", color: "inherit", textDecoration: "none" }}
          >
            {text}
          </button>
        </span>
      ),
      // sorter: (a, b) => a.employee_id.length - b.employee_id.length,
    },
  
    {
      title: "First Name",
      dataIndex: "first_name",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          <button 
            type="button"
            onClick={()=>handleEmployeeDetailPage(record.id, index)} 
            style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", border: "none", background: "none", padding: 0, cursor: "pointer", color: "inherit", textDecoration: "none" }}
          >
            <span>{text}</span>
            {(record?.is_celeb_birthday || isEventUpcoming(record?.employment?.employment_date)) && (
              <span style={{ display: "flex", gap: "6px", alignItems: "center", flexShrink: 0 }}>
                {record?.is_celeb_birthday && (
                  <span 
                    style={{
                      backgroundColor: "#10b981",
                      color: "white",
                      padding: "2px",
                      borderRadius: "50%",
                      fontSize: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      lineHeight: "1"
                    }}
                    title="Birthday"
                  >
                    <i className="fa fa-birthday-cake"></i>
                  </span>
                )}
                {isEventUpcoming(record?.employment?.employment_date) && (
                  <span 
                    style={{
                      backgroundColor: "#f59e0b",
                      color: "white",
                      padding: "2px",
                      borderRadius: "50%",
                      fontSize: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      lineHeight: "1"
                    }}
                    title="Work Anniversary"
                  >
                    <i className="fa fa-calendar-check"></i>
                  </span>
                )}
              </span>
            )}
          </button>
        </span>
      ),
      // sorter: (a, b) => a.email.length - b.email.length,
    },

    // {
    //   title: "Middle Name",
    //   dataIndex: "middle_name",
    //   sorter: true,
    //   render: (text, record, index) => (
    //     <span className="table-avatar">          
    //       <a onClick={()=>handleEmployeeDetailPage(record.id, index)}>{text}</a>
    //     </span>
    //   ),
    //   // sorter: (a, b) => a.email.length - b.email.length,
    // },
  
  
    {
      title: "Last Name",
      dataIndex: "last_name",
      sorter: true,
      render: (text, record, index) => (
        <span className="table-avatar">
          <button 
            type="button"
            onClick={()=>handleEmployeeDetailPage(record.id, index)}
            style={{ border: "none", background: "none", padding: 0, cursor: "pointer", color: "inherit", textDecoration: "none" }}
          >
            {text}
          </button>
        </span>
      ),
      // sorter: (a, b) => a.mobile.length - b.mobile.length,
    },
    {
      title: "Phone",
      dataIndex: "usercontact_company_user__mobile_no",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          <Link
                to={`tel:${record?.contact?.mobile_no}`}
              >
                {record?.contact?.mobile_no}
              </Link>
        </span>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Email",
      dataIndex: "usercontact_company_user__private_email",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          <Link to={`/employees/${record.id}`}>{record?.contact?.private_email}</Link>
          {
            !record.joined &&
            <button
              className="btn btn-link text-primary p-0 ms-2"
              style={{ 
                border: "none", 
                background: "none",
                padding: "4px",
                cursor: invitationLoader ? "not-allowed" : "pointer",
                opacity: invitationLoader ? 0.6 : 1
              }}
              title="Resend Invitation"
              disabled={invitationLoader}
              onClick={()=>handleResend(record)}
            >
              {invitationLoader ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-envelope"></i>
              )}
            </button>
          }
           
              
       
        </span>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Designation",
      dataIndex: "user_employment_company_user__position__name",
      render: (data, record) => (
        <div>
        
            <div className="dropdown">
              <span className="badge badge-soft-info">{record?.employment?.position?.name}</span>
  
            
            </div>
        
        </div>
      ),
      sorter: true,
    },
    {
      title: "Department ",
      dataIndex: "user_employment_company_user__department__name",
      sorter: true,
      render: (data, record) => (
        <div>
          {record?.employment?.department && (
            <div className="dropdown">
              <span class="badge text-bg-secondary">
                {record?.employment?.department?.name}
              </span>
  
        
            </div>
          )}
        </div>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Cost Center ",
      dataIndex: "cost_center",
      sorter: true,
      align: "center",
      render: (data, record) => (
        <div>
          {record?.cost_center?.code && (
              <span class="">
                {record?.cost_center?.code}
              </span>
  
          )}
        </div>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Employment Date",
      dataIndex: "user_employment_company_user__employment_date",
      sorter: true,
      render: (text, record) => (
        <>
          {formatDateHandler2(record?.employment?.employment_date)}
          {record?.employment?.termination_date && (
            <Tooltip
              title={`Terminated date: ${formatDateHandler2(record.employment.termination_date)}`}
            >
              <span className="d-block text-danger" style={{ fontSize: 12 }}>
                {formatDateHandler2(record.employment.termination_date)}
              </span>
            </Tooltip>
          )}
        </>
      ),

      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Profile Completion Status",
      dataIndex: "profile_completion_status",
      // sorter: true,
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", display: "flex", flexWrap: "wrap", gap: "4px" }}>
          <span className={`badge badge-soft-${statusGenerator(record?.profile_completeness?.profile_image)}`} style={{ marginRight: "4px" }}>
            Profile Image <i className={`${iconGenerator(record?.profile_completeness?.profile_image)} text-${statusGenerator(record?.profile_completeness?.profile_image)}`}/>
          </span>
          <span className={`badge badge-soft-${statusGenerator(record?.profile_completeness?.emergency_contact)}`} style={{ marginRight: "4px" }}>
            Emergency Contact <i className={`${iconGenerator(record?.profile_completeness?.emergency_contact)} text-${statusGenerator(record?.profile_completeness?.emergency_contact)}`}/>
          </span>
          <span className={`badge badge-soft-${statusGenerator(record?.profile_completeness?.documents?.emirates_id)}`} style={{ marginRight: "4px" }}>
            Emirates ID <i className={`${iconGenerator(record?.profile_completeness?.documents?.emirates_id)} text-${statusGenerator(record?.profile_completeness?.documents?.emirates_id)}`}/>
          </span>
          <span className={`badge badge-soft-${statusGenerator(record?.profile_completeness?.documents?.passport)}`} style={{ marginRight: "4px" }}>
            Passport <i className={`${iconGenerator(record?.profile_completeness?.documents?.passport)} text-${statusGenerator(record?.profile_completeness?.documents?.passport)}`}/>
          </span>
          <span className={`badge badge-soft-${statusGenerator(record?.profile_completeness?.documents?.visa)}`} style={{ marginRight: "4px" }}>
            Visa <i className={`${iconGenerator(record?.profile_completeness?.documents?.visa)} text-${statusGenerator(record?.profile_completeness?.documents?.visa)}`}/>
          </span>
          <span className={`badge badge-soft-${statusGenerator(record?.profile_completeness?.personal_info)}`} style={{ marginRight: "4px" }}>
            Personal Info <i className={`${iconGenerator(record?.profile_completeness?.personal_info)} text-${statusGenerator(record?.profile_completeness?.personal_info)}`}/>
          </span>
        </div>
      ),
    },
    // {
    //   title: "Search Name",
    //   dataIndex: "search_name",
    //   sorter: true,
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    // {
    //   title: "Balance",
    //   dataIndex: "balance",
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    // {
    //   title: "Comment",
    //   dataIndex: "comment",
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    
  ];

  // Global cache for loaded images - persists across hot reloads
  if (typeof window !== 'undefined' && !window.__loadedEmployeeImages) {
    window.__loadedEmployeeImages = new Set();
  }
  
  // Memoized Employee Card Component to prevent re-renders
  const EmployeeCard = memo(({ employee, index, handleEmployeeDetailPage, handleResend, invitationLoader, isEventUpcoming }) => {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const imageUrl = employee?.profile_image;
    
    return (
      <div
        className="col-lg-6 col-md-6 col-sm-12 col-xl-4 mb-3"
        key={`employee-${employee.id}`}
        data-employee-index={index}
      >
        <div 
          className="card shadow-sm"
          style={{
            borderRadius: "8px",
            border: "none",
            background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
            margin: 0,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            position: "relative",
            overflow: "hidden",
            cursor: "pointer",
            transition: "all 0.2s ease",
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
          }}
          onClick={() => handleEmployeeDetailPage(employee.id, index)}
        >
          <div className="card-body" style={{ 
            padding: isMobile ? "12px" : "16px",
            flex: 1,
            display: "flex",
            flexDirection: "column"
          }}>
          {/* Header with Avatar and Name */}
          <div className="d-flex align-items-start" style={{ marginBottom: "12px" }}>
            <div className="position-relative" style={{ flexShrink: 0, zIndex: 1 }}>
              <div 
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.15), 0 0 0 4px rgba(255,255,255,0.8)",
                  background: "#f0f0f0",
                  transition: "transform 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  border: employee?.gender?.toLowerCase() === "female" 
                    ? "2px solid #f093fb" 
                    : employee?.gender?.toLowerCase() === "male"
                    ? "2px solid #4facfe"
                    : "2px solid #e9ecef"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                {employee?.profile_image ? (
                  <img
                    src={imageUrl}
                    alt="User"
                    loading="lazy"
                    style={{ 
                      objectFit: "cover", 
                      width: "100%", 
                      height: "100%",
                      borderRadius: "50%"
                    }}
                    onLoad={(e) => {
                      if (imageUrl && window.__loadedEmployeeImages) {
                        window.__loadedEmployeeImages.add(imageUrl);
                      }
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                ) : null}
                <div 
                  style={{
                    width: "100%",
                    height: "100%",
                    display: employee?.profile_image ? "none" : "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f0f0f0",
                    color: "#adb5bd",
                    borderRadius: "50%",
                    position: employee?.profile_image ? "absolute" : "relative",
                    top: 0,
                    left: 0
                  }}
                >
                  <i className="fa fa-user" style={{ fontSize: "28px" }}></i>
                </div>
              </div>
              {(employee?.is_celeb_birthday || isEventUpcoming(employee?.employment?.employment_date)) && (
                <div style={{
                  position: "absolute",
                  bottom: "-6px",
                  right: "-6px",
                  display: "flex",
                  gap: "6px",
                  zIndex: 2
                }}>
                  {employee?.is_celeb_birthday && (
                    <span 
                      style={{
                        backgroundColor: "#10b981",
                        color: "white",
                        padding: "5px",
                        borderRadius: "50%",
                        fontSize: "13px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "28px",
                        height: "28px",
                        lineHeight: "1",
                        boxShadow: "0 4px 12px rgba(16, 185, 129, 0.5)",
                        border: "3px solid white",
                        animation: "pulse 2s infinite"
                      }}
                      title="Birthday"
                    >
                      <i className="fa fa-birthday-cake"></i>
                    </span>
                  )}
                  {isEventUpcoming(employee?.employment?.employment_date) && (
                    <span 
                      style={{
                        backgroundColor: "#f59e0b",
                        color: "white",
                        padding: "5px",
                        borderRadius: "50%",
                        fontSize: "13px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "28px",
                        height: "28px",
                        lineHeight: "1",
                        boxShadow: "0 4px 12px rgba(245, 158, 11, 0.5)",
                        border: "3px solid white",
                        animation: "pulse 2s infinite"
                      }}
                      title="Work Anniversary"
                    >
                      <i className="fa fa-calendar-check"></i>
                    </span>
                  )}
                </div>
              )}
            </div>
            
            <div className="flex-grow-1 ms-3" style={{ minWidth: 0, zIndex: 1 }}>
              <h4 style={{ 
                fontSize: isMobile ? "15px" : "16px",
                fontWeight: "600",
                color: "#1f2937",
                marginBottom: "2px",
                lineHeight: "1.3"
              }}>
                {employee.first_name} {employee?.last_name}
              </h4>
              {employee?.employment?.position?.name && (
                <div style={{ 
                  fontSize: "12px",
                  color: "#6b7280",
                  marginBottom: "0px"
                }}>
                  {employee.employment.position.name}
                </div>
              )}
            </div>
          </div>

          {/* Details Section */}
          <div style={{
            borderTop: "1px solid #e5e7eb",
            paddingTop: "12px",
            marginTop: "auto",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
          }}>
            <div className="row g-2">
              {employee.emp_no && (
                <div className="col-6">
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                    Emp No
                  </div>
                  <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                    {employee.emp_no}
                  </div>
                </div>
              )}
              {employee.email && (
                <div className="col-6">
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                    Email
                  </div>
                  <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {employee.email}
                    {!employee.joined && (
                      <button
                        className="btn btn-link p-0 ms-1"
                        style={{ 
                          border: "none", 
                          background: "none",
                          padding: "0",
                          cursor: invitationLoader ? "not-allowed" : "pointer",
                          opacity: invitationLoader ? 0.6 : 1,
                          fontSize: "10px",
                          color: "#D3001A"
                        }}
                        title="Resend Invitation"
                        disabled={invitationLoader}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleResend(employee);
                        }}
                      >
                        {invitationLoader ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          <i className="fa fa-paper-plane"></i>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              )}
              {employee.company_phone_number && (
                <div className="col-6">
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                    Phone
                  </div>
                  <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                    {employee.company_phone_number}
                  </div>
                </div>
              )}
              {employee?.store?.name && (
                <div className="col-6">
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                    Store
                  </div>
                  <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {employee.store.name}
                  </div>
                </div>
              )}
            </div>

            {/* Footer with Cost Center and Status */}
            {(employee.cost_center?.code || employee?.status !== undefined) && (
              <div className="d-flex align-items-center justify-content-between" style={{ borderTop: "1px solid #e5e7eb", paddingTop: "12px", marginTop: "auto" }}>
                {employee.cost_center?.code && (
                  <div style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "500" }}>
                    {employee.cost_center.code}
                  </div>
                )}
                {employee?.status !== undefined && (
                  <span className={`badge badge-soft-${employee?.status ? "success" : "danger"}`} style={{
                    fontSize: "11px",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontWeight: "600"
                  }}>
                    {employee?.status ? "Active" : "Inactive"}
                  </span>
                )}
              </div>
            )}
          </div>
          </div>
        </div>
      </div>
    );
  }, (prevProps, nextProps) => {
    // Custom comparison function - return true if props are equal (skip re-render)
    // Only re-render if employee data actually changed
    // Compare by value, not by reference, to handle object reference changes
    
    // If employee ID changed, it's a different employee - need to re-render
    if (prevProps.employee.id !== nextProps.employee.id) {
      return false; // Re-render
    }
    
    // Same employee - check if any relevant data changed
    const employeeChanged = 
      prevProps.employee.profile_image !== nextProps.employee.profile_image ||
      prevProps.employee.first_name !== nextProps.employee.first_name ||
      prevProps.employee.last_name !== nextProps.employee.last_name ||
      prevProps.employee.email !== nextProps.employee.email ||
      prevProps.employee.status !== nextProps.employee.status ||
      prevProps.employee.is_celeb_birthday !== nextProps.employee.is_celeb_birthday ||
      prevProps.employee.gender !== nextProps.employee.gender ||
      prevProps.employee.emp_no !== nextProps.employee.emp_no ||
      prevProps.employee.company_phone_number !== nextProps.employee.company_phone_number ||
      prevProps.employee.joined !== nextProps.employee.joined;
    
    const invitationLoaderChanged = prevProps.invitationLoader !== nextProps.invitationLoader;
    
    // Skip re-render if nothing important changed
    // Note: We don't check function references (handleEmployeeDetailPage, handleResend, isEventUpcoming)
    // because they should be stable (memoized with useCallback)
    return !employeeChanged && !invitationLoaderChanged;
  });

  const GridView = () => {
    if (loading && employeeData.length === 0) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {employeeData.map((employee, index) => {
            // Create a stable employee object reference using useMemo would be ideal,
            // but since we're in a map, we'll rely on the memo comparison function
            return (
              <EmployeeCard
                key={`employee-${employee.id}`}
                employee={employee}
                index={index}
                handleEmployeeDetailPage={handleEmployeeDetailPage}
                handleResend={handleResend}
                invitationLoader={invitationLoader}
                isEventUpcoming={isEventUpcoming}
              />
            );
          })}
        </>
      );
    }
  };

  
// // Custom row component

  
// // Custom row component
// const CustomRow = (props) => {
//   const { children, ...restProps } = props;
//   const anniversaryStatus = isEventUpcoming(props?.record?.employment?.employment_date);

//   return (
//     <>
   
//     {
//       props?.record?.is_celeb_birthday &&
//       <Badge.Ribbon 
//     text={ "Birthday 🎉"} 
//     color={"green"}
//     placement={"start"}
//     style={{ zIndex: 1 , position: 'absolute', top: 0, left: -10 }}
//   >
//     <span></span>
//   </Badge.Ribbon>
//     }
//     {
//       anniversaryStatus  &&
//       <Badge.Ribbon 
//     text={ "Anniversary 🎉"} 
//     color={"yellow"}
//     placement={"start"}
//     style={{ zIndex: 1 , position: 'absolute', top: props?.record?.is_celeb_birthday ? 25 : 0, left: -10 }}
//   >
//     <span></span>
//   </Badge.Ribbon>
//      }
    
//   <tr
//   {...restProps}
//   style={{
//     backgroundColor: '#f6f6f6',
//     cursor: 'pointer',
//   }}
//   onClick={() => console.log('Row clicked:', props['data-row-key'])}
// >
//   {children}
// </tr>
// </>
//   );
// };

  return (
    <div>
      <style>{`
        .modern-table .ant-table-tbody > tr {
          background-color: #ffffff !important;
        }
        .modern-table .ant-table-tbody > tr:nth-of-type(even) {
          background-color: #ffffff !important;
        }
        .modern-table .ant-table-tbody > tr:nth-of-type(odd) {
          background-color: #ffffff !important;
        }
        .modern-table .ant-table-thead > tr > th {
          background-color: #f8f9fa !important;
          font-weight: 600;
          color: #333;
          border-bottom: 2px solid #e0e0e0;
          padding: 10px 12px;
          font-size: 13px;
        }
        .modern-table .ant-table-tbody > tr > td {
          padding: 10px 12px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 13px;
        }
        .modern-table .ant-table-tbody > tr:hover > td {
          background-color: #f8f9fa !important;
        }
      `}</style>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.9;
          }
        }
      `}</style>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employee"
            title="Dashboard"
            subtitle="Employee"
            modal="#add_employee"
            name="Add Employee"
            // Linkname="/employees"
            // Linkname1="/employees-list"
            view={view}
            setView={setView}
            showModal={false}
          />
          <EmployeeListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search employee"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            appliedFilterCount={appliedFilterCount}
            handleExport={handleExport}
            exportLoading={exportLoading}
             />

          {view === "grid" ? (
            <div className="row">
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination

                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}

                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loadingMore}
                            disabled={loadingMore}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                          
                        );
                      }
                      return null;
                    }}

                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={employeeData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      components={{
                        body: {
                          row: CustomRow,
                        },
                      }}
                      onRow={(record, index) => ({
                        record,
                        index,
                        style: {
                          cursor: 'pointer',
                          transition: 'background-color 0.2s',
                          backgroundColor: '#ffffff'
                        },
                        onMouseEnter: (e) => {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                        },
                        onMouseLeave: (e) => {
                          e.currentTarget.style.backgroundColor = '#ffffff';
                        }
                      })}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <AllEmployeeAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Employee" />

      <FilterDrawer


        searchPlaceholder={"Search employee"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}

        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
        handleClearAll={handleClearAll}
        isFilterDirty={isFilterDirty}
      />
      {/* Delete Modal */}
    </div>
  );
};

export default AllEmployee;
